<template>
  <div class="repayment-item" @click="handleClick">
    <div class="repayment-info">
      <div class="info-top">
        <div class="period">{{ itemData.issueNo }}/{{ num }}期</div>
        <div class="repayment-date">
          还款日期：{{ itemData.dueRepaymentTime }}
        </div>
      </div>
      <div class="repayment-amount">
        <div class="checkbox">
          <input
            type="checkbox"
            ref="repaymentCheckbox"
            v-model="isChecked"
            @change.stop="handleChange"
          />
        </div>
        <div class="info-bottom">
          <div class="principal">本金{{ itemData.principalAmount }}+</div>
          <div class="interest">利息{{ itemData.interestAmount }}</div>
          <div class="serviceFee" v-if="itemData.serviceFeeAmount > 0">
            +服务费{{ itemData.serviceFeeAmount }}
          </div>
          <div class="penalty" v-if="itemData.status == 2">
            +罚金 {{ itemData.penaltyAmount }}
          </div>
        </div>
        <div class="amount">
          <span class="amount-tip">¥</span
          >{{
            (
              itemData.principalAmount +
              itemData.interestAmount +
              itemData.penaltyAmount +
              itemData.serviceFeeAmount
            ).toFixed(2)
          }}
        </div>
      </div>
    </div>

    <div class="repayment-status" v-if="itemData.status == 2">
      <div class="status">{{ orderStatusList[itemData.status] }}</div>
    </div>
    <div class="amount-due" v-if="itemData.status == 1">
      <div class="status">{{ orderStatusList[itemData.status] }}</div>
    </div>
  </div>
</template>

<script>
import { uniqueById } from "@/utils/utils.js";
import { orderStatusList } from "@/utils/const.js";
export default {
  name: "repaymentItem",
  props: {
    itemData: {
      type: Object,
      default: () => {},
    },
    num: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isChecked: false,
      uniqueById,
      orderStatusList,
    };
  },
  async mounted() {},
  methods: {
    handleChange() {
      this.$store.commit(
        "setBillIdList",
        this.isChecked
          ? [...this.$store.state.billIdList, this.itemData.borrowOrderIssueId]
          : this.$store.state.billIdList.filter(
              (item) => item !== this.itemData.borrowOrderIssueId,
            ),
      );
      this.$store.commit(
        "setSelectedBillList",
        this.isChecked
          ? [...this.$store.state.selectedBillList, this.itemData]
          : this.$store.state.selectedBillList.filter(
              (item) =>
                item.borrowOrderIssueId !== this.itemData.borrowOrderIssueId,
            ),
      );
    },
    handleClick() {
      this.isChecked = !this.$refs.repaymentCheckbox.checked;
      this.$store.commit(
        "setBillIdList",
        this.isChecked
          ? [...this.$store.state.billIdList, this.itemData.borrowOrderIssueId]
          : this.$store.state.billIdList.filter(
              (item) => item !== this.itemData.borrowOrderIssueId,
            ),
      );
      this.$store.commit(
        "setSelectedBillList",
        this.isChecked
          ? [...this.$store.state.selectedBillList, this.itemData]
          : this.$store.state.selectedBillList.filter(
              (item) =>
                item.borrowOrderIssueId !== this.itemData.borrowOrderIssueId,
            ),
      );
    },
  },
};
</script>

<style scoped lang="scss">
.repayment-item {
  padding: 16px 9px 10px 9px;
  border-radius: 8px;
  background: #ffffff;
  position: relative;
  display: flex;
  margin-bottom: 10px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.06);
  .repayment-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    .info-top,
    .info-bottom {
      display: flex;
      align-items: center;
    }
    .info-top {
      font-size: 12px;
      .period {
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #D4A038;
        padding: 2px 0px;
        color: #D4A038;
        font-family: YEFONTAoYeHei, YEFONTAoYeHei;
        font-weight: 600;
        text-align: center;
        width: 46px;
      }
      .repayment-date {
        color: #333333;
        margin-left: 6px;
        font-size: 14px;
      }
    }
    .info-bottom {
      font-size: 11px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      /* 列与列之间间距 10px，行与行（换行后）之间间距 8px */
      column-gap: 0px;
      row-gap: 8px; /* 🌟 只要换行，下方的元素自动产生 8px 的顶部间距 */
      color: #999999;
    }
  }
  .repayment-amount {
    font-size: 12px;
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
    padding-top: 10px;
    .amount {
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 20px;
      color: #333333;
      margin-left: auto; /* 核心代码：自动撑开左侧间距 */
      .amount-tip {
        font-size: 12px;
      }
    }
  }
  .repayment-status {
    position: absolute;
    right: 0px;
    top: 0px;
    .status {
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      padding: 2px 6px;
      background-image: url("@/assets/style/overdue-bg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  .amount-due {
    position: absolute;
    right: 0px;
    top: 0px;
    .status {
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      padding: 2px 6px;
      background-image: url("@/assets/style/Amount-due.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
}
input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid #cfcfcf;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  flex-shrink: 0;

  &:checked {
    background-color: #F24334;
    border: none;
    &::after {
      content: "";
      width: 8px;
      height: 4px;
      border: 2px solid #fff;
      border-top: none;
      border-right: none;
      transform: rotate(-45deg);
      margin-top: -2px;
    }
  }
}
</style>
